import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import * as styles from './price-option.style';

/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
import { jsx as ___EmotionJSX } from "@emotion/core";
var PriceOption = props => ___EmotionJSX("div", {
  css: styles.filter
}, ___EmotionJSX("div", {
  css: styles.title
}, "Price Option"), ___EmotionJSX("div", {
  css: styles.withPrice
}, ___EmotionJSX("label", {
  htmlFor: "toggle-".concat(props.name),
  css: styles.label
}, "Show properties with price only"), ___EmotionJSX(Toggle, {
  id: "toggle-".concat(props.name),
  checked: props.value || false,
  icons: false,
  css: styles.toggle,
  onChange: event => props.onChange({
    [props.name]: event.target.checked
  })
})));
PriceOption.propTypes = {
  name: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func
};
PriceOption.defaultProps = {
  name: 'onlyWithPrice',
  value: false,
  onChange: () => {}
};
export default PriceOption;